import { Controller } from "@hotwired/stimulus"

// Toggles the event-card preview visibility from the "Include Event Card"
// checkbox on the Compose step. The persisted include_event_card flag is what
// the send path will honor; this just reflects the choice in the preview.
export default class extends Controller {
  static targets = ["checkbox", "preview"]

  connect() { this.toggle() }

  toggle() {
    if (!this.hasPreviewTarget || !this.hasCheckboxTarget) return
    this.previewTarget.classList.toggle("d-none", !this.checkboxTarget.checked)
  }
}
